import {
  api_edit_profile_settings_path,
  api_profile_setting_path,
  api_validate_username_path,
} from '../../routes';
import request from './request';

type entityId = number;

type Entity = {
  label: string;
  value: number;
};

// All params are optional because you can save a portion of the profile
export interface SanitizedProfileSettingsParams {
  bio?: string;
  books?: entityId[];
  company_name?: string;
  finding_new_job?: boolean;
  finding_new_job_desc?: string;
  hiring?: boolean;
  hiring_desc?: string;
  instagram?: string;
  interests?: entityId[];
  investing_in_startups: boolean;
  investing_in_startups_desc: string;
  linkedin?: string;
  location?: entityId;
  mentioning_disabled?: boolean;
  message_enabled?: boolean;
  name?: string;
  one_line_bio?: string;
  personal_url?: string;
  picture?: string;
  profile_enabled?: boolean;
  providing_services?: boolean;
  providing_services_desc?: string;
  short_bio?: string;
  shows?: entityId[];
  skills?: entityId[];
  sports_play?: entityId[];
  sports_watch?: entityId[];
  title_at_company?: string;
  topics?: entityId[];
  twitter?: string;
  username?: string;
  withImage?: boolean;
  vacation_spots?: entityId[];
}

export interface Profile {
  avatarUrl: string;
  bio: string;
  company: Entity;
  favoriteBooks: Entity[];
  favoriteShows: Entity[];
  favoriteSportsToPlay: Entity[];
  favoriteSportsToWatch: Entity[];
  favoriteVacationSpots: Entity[];
  findingNewJob: boolean;
  findingNewJobDesc: string;
  hiring: boolean;
  hiringDesc: string;
  id: number;
  instagram: string;
  interests: Entity[];
  investingInStartups: boolean;
  investingInStartupsDesc: string;
  isStaff: boolean;
  linkedin: string;
  location: Entity;
  name: string;
  oneLineBio: string;
  mentioningDisabled: boolean;
  messageEnabled: boolean;
  messagingBlocked: boolean;
  personalUrl: string;
  profileEnabled: boolean;
  providingServices: boolean;
  providingServicesDesc: string;
  shortBio: string;
  skills: Entity[];
  titleAtCompany: Entity;
  topics: Entity[];
  twitter: string;
  userId: number;
  username: string;
}

export async function fetchProfileSettings(): Promise<Profile> {
  const resp = await request('get', api_edit_profile_settings_path());
  return resp;
}

export async function updateProfileSettings(
  userId: number | string,
  values: SanitizedProfileSettingsParams
): Promise<Profile> {
  const { withImage, ...sanitizedValues } = values;
  const formData = new FormData();
  if (withImage) {
    for (const key in sanitizedValues) {
      formData.append(key, sanitizedValues[key]);
    }
  }

  const resp = await request(
    'put',
    api_profile_setting_path(userId),
    withImage ? formData : sanitizedValues,
    withImage
  );
  return resp;
}

export async function checkUsername(value: { username: string }): Promise<{ success: boolean }> {
  const resp = await request('get', api_validate_username_path(value));
  return resp;
}
